// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-uid-copy-line[data-v-a063266a]{padding:8px 0}[data-v-a063266a]  .payment-uid-copy-input .el-input__inner{font-size:11px !important}.payment-uid-copy-line .over-input[data-v-a063266a]{right:4px !important}.missing-amount[data-v-a063266a]{width:fit-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
